{
	"cancel": "Anuler",
	"ok": "Ok",
	"title": "Confirmation requise"
}
